import { ArpeggiSupportedChain } from '@arpeggi/shared'

type ChainCurrency = 'ETH' | 'MATIC' | 'OP'

export const getChainCurrency = (chain: ArpeggiSupportedChain): ChainCurrency | undefined => {
  if (!chain) return undefined

  if (chain === 'ethereum') return 'ETH'
  else if (chain === 'polygon') return 'MATIC'
  else if (chain === 'optimism') return 'OP'

  return undefined
}
